import * as server from '../entries/pages/dossier/agent-memory/_page.server.ts.js';

export const index = 3;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/dossier/agent-memory/_page.svelte.js')).default;
export { server };
export const server_id = "src/routes/dossier/agent-memory/+page.server.ts";
export const imports = ["_app/immutable/nodes/3.Cml8enOG.js","_app/immutable/chunks/kCE9wz0g.js","_app/immutable/chunks/x-hq5fDG.js","_app/immutable/chunks/1NK_OeRJ.js","_app/immutable/chunks/B1veta3r.js","_app/immutable/chunks/C6KhNEX3.js","_app/immutable/chunks/BZ4lcC0v.js","_app/immutable/chunks/DIljKPJN.js","_app/immutable/chunks/Bu7F9NOv.js"];
export const stylesheets = ["_app/immutable/assets/AppShell.CDPwj3zU.css","_app/immutable/assets/3.vWQUAHjz.css"];
export const fonts = [];
